import { Timestamp } from 'firebase/firestore';

import { ICard } from './card';
import { IUserProfile } from './user';

export const enum StoryRenderModes {
  BLOCK = 'BLOCK',
  FLEXIBLE = 'FLEXIBLE',
}

export interface IStoryFirebase {
  meta: IStoryMetaFirebase;
  title: string;
  cards: ICard[];
  posters?: Partial<
    Record<
      'feed' | 'linkedin' | 'sharing',
      { fileUrl: string; fileName: string }
    >
  > | null;
  author?: IUserProfile;
}

interface IStoryMetaFirebase {
  userId: string;
  companyId: string;
  collectionId: string | null;
  description: string;
  topicsList: string[];
  topicsPermutations: string[];
  duration: number;
  createdAt: Timestamp;
  publishedAt: Timestamp | null;
  scheduledPublishAt: Timestamp | null;
  showInFeed: boolean;
  public: boolean;
  updatedAt: Timestamp | null;
  renderMode?: StoryRenderModes;
  team: string[];
  emailAlertsEnabled: boolean;
  accessKey: string | null;
  qrText: string | null;
}

export interface IStory extends Omit<IStoryFirebase, 'meta'> {
  id: string;
  meta: IStoryMeta;
}

export interface IStoryMeta
  extends Omit<
    IStoryMetaFirebase,
    'createdAt' | 'publishedAt' | 'updatedAt' | 'scheduledPublishAt'
  > {
  createdAt: string | null;
  publishedAt: string | null;
  updatedAt: string | null;
  scheduledPublishAt: string | null;
}

export interface IAlgoliaStory extends Omit<IStory, 'id' | 'cards'> {
  objectID: string;
}

export interface IMuxVideo {
  storyId: string;
  fileName: string;
  mux?: {
    id: string;
    status: string;
    passthrough: string;
    tracks?: {
      type: string;
      max_width?: number;
      max_height?: number;
    }[];
    playback_ids: {
      id: string;
    }[];
  };
}
